// extracted by mini-css-extract-plugin
export default {"subTitle":"TabQuattro_subTitle__it5zr","title":"TabQuattro_title__4spL9","textField":"TabQuattro_textField__17Ibn","disabledTextField":"TabQuattro_disabledTextField__AiER6"};